export default __webpack_public_path__ + "static/media/game-pagetype-game_game.98b5ea4f.svg";